import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";

import { fetchUrl } from "../../../../functions/fetchUrl";

import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const SubRenews = ({ table }) => {

  useState("Loading...");
  const today = new Date();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [valueDateFrom, setValueDateFrom] = useState(today);
  const [valueDateTo, setValueDateTo] = useState(today);

  const columns = [
    {
      field: "total_subscribed",
      headerName: "New Subs",
      width: 100,
    },
    {
      field: "first_bills",
      headerName: "First Billing",
      width: 100,
    },
    {
      field: "renewals",
      headerName: "Renews",
      width: 100,
    },
    {
      field: "unsubscribed",
      headerName: "Unsubs",
      width: 100,
    },
  ];


  useEffect(() => {
    setData([]);
    //     "valueDateTo": "01-20-2023"

    const monthFromNumber = (valueDateFrom.getMonth() + 1).toString().padStart(2, "0");
    const dayFromNumber = valueDateFrom.getDate().toString().padStart(2, "0");
    const yearFromNumber = valueDateFrom.getFullYear();

    const monthToNumber = (valueDateTo.getMonth() + 1).toString().padStart(2, "0");
    const dayToNumber = valueDateTo.getDate().toString().padStart(2, "0");
    const yearToNumber = valueDateTo.getFullYear();

    const dateFrom =
      monthFromNumber + "-" + dayFromNumber + "-" + yearFromNumber;

    const dateTo = monthToNumber + "-" + dayToNumber + "-" + yearToNumber;

    const bodySend = {
      valueDate: dateFrom,
      valueToDate: dateTo,
    };

    const fetchData = async () => {
      setLoading(true);
      const response = await fetchUrl({
        method: "POST",
        apiName: table,
        reqBody: bodySend
      });
      if (response.success) {
        // setData(response.result);
        setData([{
          ...response.result[0],
          id: 1, // Or any unique identifier
        }]);

        setLoading(false);
      }
    };
    fetchData();
  }, [table, valueDateFrom, valueDateTo]);

  return (
    <>
      <div style={{ display: "inline-block", margin: "10px 10px" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="From:"
            value={valueDateFrom}
            onChange={(newValue) => {
              setValueDateFrom(new Date(newValue));
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </div>
      <div style={{ display: "inline-block", margin: "0 10px" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="To:"
            value={valueDateTo}
            onChange={(newValue) => {
              setValueDateTo(new Date(newValue));
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </div>
      <div>
        <DataGrid
          className="ml-1"
          rows={data}
          columns={columns}
          pageSize={15}
          rowsPerPageOptions={[5]}
          style={{ height: "40vh" }}
          getRowId={(data) => data.id}
          loading={loading}
        />
      </div>
    </>
  );
};

export default SubRenews;
